import EditIcon from './EditIcon';
import Logo from './Logo';
import SkipArrow from './SkipArrow';
import Logo1 from './Logo1';
import Dashboard from './Dashboard';
import Music from './Music';
import Upload from './Upload';
import Reports from './Reports';
import Financial from './Financial';
import Profile from './Profile';
import ContactSupport from './ContactSupport';
import EmailVerifyIcon from './EmailVerifyIcon';
import BigUpload from './BigUpload';
import GoogleIcon from './GoogleIcon';
import DeclineIcon from './DeclineIcon';
import EyeOff from './EyeOff';
import EyeOn from './EyeOn';
import Volume from './Volume';
import Play from './Play';
import UpArrow from './UpArrow';
import DownArrow from './DownArrow';
import SearchIcon from './SearchIcon';
import AddIcon from './AddIcon';
import AddImage from './AddImage';
import Novolume from './NoVolume';
import PauseIcon from './PauseIcon';
import NoData from './NoDataFound';
import Previous from './Previous';
import Next from './Next';
import VolumeIcon from './VolumeIcon';
import Mute from './Mute';
import CloseIcon from './CloseIcon';
import Media from './Media';
import Close2 from './Close2';
import Document from './Document';
import DeleteIcon from './DeleteIcon';

import { ICONS } from '@/constants/icons.constants';

export const ICON_NAME_VS_CMP = {
  [ICONS.EDIT]: EditIcon,
  [ICONS.LOGO]: Logo,
  [ICONS.SKIP_ARROW]: SkipArrow,
  [ICONS.LOGO1]: Logo1,
  [ICONS.DASHBOARD]: Dashboard,
  [ICONS.MUSIC]: Music,
  [ICONS.UPLOAD]: Upload,
  [ICONS.DOCUMENT]: Document,
  [ICONS.REPORTS]: Reports,
  [ICONS.FINANCIAL]: Financial,
  [ICONS.PROFILE]: Profile,
  [ICONS.CONTACT_SUPPORT]: ContactSupport,
  [ICONS.EMAIL_VERIFY]: EmailVerifyIcon,
  [ICONS.BIG_UPLOAD]: BigUpload,
  [ICONS.GOOGLE_ICON]: GoogleIcon,
  [ICONS.DECLINEICON]: DeclineIcon,
  [ICONS.EYEON]: EyeOn,
  [ICONS.EYEOFF]: EyeOff,
  [ICONS.PLAY]: Play,
  [ICONS.PAUSE]: Play, // TODO: change this to Pause
  [ICONS.VOLUME]: Volume,
  [ICONS.UP_ARROW]: UpArrow,
  [ICONS.DOWN_ARROW]: DownArrow,
  [ICONS.SEARCH_ICON]: SearchIcon,
  [ICONS.ADD_ICON]: AddIcon,
  [ICONS.ADD_IMAGE]: AddImage,
  [ICONS.NO_VOLUME]: Novolume,
  [ICONS.PAUSE_ICON]: PauseIcon,
  [ICONS.NODATA]: NoData,
  [ICONS.PREVIOUS]: Previous,
  [ICONS.NEXT]: Next,
  [ICONS.VOLUMEICON]: VolumeIcon,
  [ICONS.MUTE]: Mute,
  [ICONS.CLOSE_ICON]: CloseIcon,
  [ICONS.MEDIA]: Media,
  [ICONS.CLOSE2]: Close2,
  [ICONS.DELETE]: DeleteIcon,
};
